export default "__VITE_ASSET__hJeVfVA$__"